import { startCase, uniqueId } from "lodash";
import { Component } from "react";
import { PractitionerStatuses, LocationStatuses, PractitionerAtLocationStatuses, NppesStatuses } from "@app/exports/enumerations";
import { QESCheckbox } from "@app/shared/qes-standards";

interface AccuracyStatusFilterProps {
  disabled: boolean;
  onPractitionerStatusChange: (status: PractitionerStatuses) => void;
  onLocationStatusChange: (status: LocationStatuses) => void;
  onPractitionerAtLocationStatusChange: (status: PractitionerAtLocationStatuses) => void;
  onNppesStatusChange: (status: NppesStatuses) => void;
  practitionerStatusRowIds: PractitionerStatuses[];
  locationStatusRowIds: LocationStatuses[];
  practitionerAtLocationStatusRowIds: PractitionerAtLocationStatuses[];
  nppesStatusRowIds: NppesStatuses[];
}

export default class AccuracyStatusFilter extends Component<AccuracyStatusFilterProps> {

  public render() {
    return (
      <>
        <p className="lead mb0 font-weight-bold">Status Filter{this.props.disabled && <span>: Selected</span>}</p>
        <p>Please select the statuses to include:</p>

        <div className="row">
          <div className="col-12 col-sm-3">
            <p>Practitioner Statuses</p>
            {Object.values(PractitionerStatuses).map((v, i) => {
              const inputId = uniqueId(v);

              return (
                <QESCheckbox
                  containerClassName="form-check"
                  className="form-check-input mt-0"
                  id={inputId}
                  key={v}
                  label={startCase(v)}
                  value={v}
                  checked={this.props.practitionerStatusRowIds.indexOf(v) > -1}
                  onChange={() => this.props.onPractitionerStatusChange(v)}
                  testId={`practitioner-status-checkbock--${i}`}
                />
              );
            })}
          </div>
          <div className="col-12 col-sm-3">
            <p>NPPES Statuses</p>
            {Object.values(NppesStatuses).map((v, i) => {
              const inputId = uniqueId(v);

              return (
                <QESCheckbox
                  containerClassName="form-check"
                  className="form-check-input mt-0"
                  id={inputId}
                  key={v}
                  label={startCase(v)}
                  value={v}
                  checked={this.props.nppesStatusRowIds.indexOf(v) > -1}
                  onChange={() => this.props.onNppesStatusChange(v)}
                  testId={`nppes-status-checkbock--${i}`}
                />
              );
            })}
          </div>
          <div className="col-12 col-sm-3">
            <p>Location Statuses</p>
            {Object.values(LocationStatuses).map((v, i) => {
              const inputId = uniqueId(v);

              return (
                <QESCheckbox
                  containerClassName="form-check"
                  className="form-check-input mt-0"
                  id={inputId}
                  key={v}
                  label={startCase(v)}
                  value={v}
                  checked={this.props.locationStatusRowIds.indexOf(v) > -1}
                  onChange={() => this.props.onLocationStatusChange(v)}
                  testId={`location-status-checkbock--${i}`}
                />
              );
            })}
          </div>
          <div className="col-12 col-sm-3">
            <p>Practitioner At Location Statuses</p>
            {Object.values(PractitionerAtLocationStatuses).map((v, i) => {
              const inputId = uniqueId(v);

              return (
                <QESCheckbox
                  containerClassName="form-check"
                  className="form-check-input mt-0"
                  id={inputId}
                  key={v}
                  label={startCase(v)}
                  value={v}
                  checked={this.props.practitionerAtLocationStatusRowIds.indexOf(v) > -1}
                  onChange={() => this.props.onPractitionerAtLocationStatusChange(v)}
                  testId={`practitioner-at-location-status-checkbock--${i}`}
                />
              );
            })}
          </div>
        </div>
      </>
    );
  }
}
